import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotel-room-amenities/types', request)
}

async function post(queryParams, amenitiesData) {
    const url = `/api/hotel-room-amenities?productId=${queryParams.productId}&hotelId=${queryParams.hotelId}&roomId=${queryParams.roomId}`
    return await postMethod(url, amenitiesData)
}

export {get, post}
